import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FiltroRelLiquidacao } from '../../../models/pagamento/filtro-rel-liquidacao';
import { BaseComponentService } from '../../../services/base-component.service';
import { CloseModal } from '../../../shared/enum/shared.enum';
import { RelLiquidacaoComponent } from '../rel-liquidacao/rel-liquidacao.component';

@Component({
  selector: 'gpa-filtro-rel-liquidacao',
  templateUrl: './filtro-rel-liquidacao.component.html',
  providers: [BaseComponentService]
})
export class FiltroRelLiquidacaoComponent extends BaseComponentService implements OnInit {

  @Input() filtro: FiltroRelLiquidacao;

  formFiltro: FormGroup;

  escopos: any[] = [
    {id: '1', descricao: 'Igual a'},
    {id: '2', descricao: 'Intervalo'}
  ]

  tiposInfoCredor: any[] = [
    {
      id: '1',
      descricao: 'Código',
      mask: '0000.00000-0',
      pattern: '[0-9]{4}[\.]?[0-9]{5}[-]?[0-9]{1}',
      msgRequerido: 'Informe o código.'
    },
    {
      id: '2',
      descricao: 'CPF',
      mask: '000.000.000-00',
      pattern: '[0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2}',
      msgRequerido: 'Informe o CPF.'
    },
    {
      id: '3',
      descricao: 'CNPJ',
      mask: 'AA.AAA.AAA/AAAA-00',
      pattern: '[A-Za-z0-9]{2}[\.]?[A-Za-z0-9]{3}[\.]?[A-Za-z0-9]{3}[/]?[A-Za-z0-9]{4}[-]?[0-9]{2}',
      msgRequerido: 'Informe o CNPJ.'
    }
  ]

  /*
   *  Máscaras dos controles do formulário
   */
  pedEmpLiqMask = '00000.0000.00.0000000-0';
  processoSeiMask = '9000.0000.0000.0000000-00 || 0000.0000.0000.0000000-00';
  codigoCredorMask = '0000.00000-00';
  cpfMask = '000.000.000-00';
  cnpjMask = 'AA.AAA.AAA/AAAA-00';

  // armazenará umas das 3 máscaras (codigo, CPF ou CNPJ) para a informação do credor e  credor da consignatária.
  credorMask: string;
  credorMaskConsignataria: string;

  /*
   *  Patterns dos controles do formulário
   *  Os patterns de cpf e cnpj estão no array de tipos de informações do credor
   */
  pedEmpLiqPattern = '[0-9]{5}[\.]?[0-9]{4}[\.]?[0-9]{2}[\.]?[0-9]{7}[-]?[0-9]{1}';
  processoSeiPattern = '[0-9]?[0-9]{3}[\.]?[0-9]{4}[\.]?[0-9]{4}[\.]?[0-9]{7}[-]?[0-9]{2}';

  /*
   *   Variáveis relacionadas à validação do formulário com mensagem de erro de cada controle.
   */
  msgErroFormatoInvalido = 'Informe um formato válido.';
  msgErroCredorRequerido: string;
  msgErroCredorConsignatariaRequerido: string;
  msgErroMaxDataInicial: string;

   /*
   *   Variáveis relacionadas ao label de cada controle de valor inicial de PED, EMP, LIQ e Valor.
   *   A depender do valor do escopo selecionado seus valores alternaraão entre "Inicial" e "Valor".
   */
  labelNumPedInicial: string;
  labelNumEmpInicial: string;
  labelNumLiqInicial: string;
  labelValorLiqInicial: string;

  exibirNumPedFinal = false;
  exibirNumEmpFinal = false;
  exibirNumLiqFinal = false;
  exibirValorLiqFinal = false;

  hoje = new Date();

  ngOnInit() {
    this.criarFormulario();
    this.atualizarFormulario();
  }

  criarFormulario() {
    this.formFiltro = this.fb.group({
      dataInicial: this.fb.control('', [Validators.required, validateMaxDate(this.hoje)]),
      dataFinal: this.fb.control('', [Validators.required, validateMaxDate(this.hoje)]),
      escopoNumeroPed: this.fb.control(''),
      numeroPedInicial: this.fb.control({value: '', disabled: true}, Validators.pattern(this.pedEmpLiqPattern)),
      numeroPedFinal: this.fb.control('', Validators.pattern(this.pedEmpLiqPattern)),
      escopoNumeroEmp: this.fb.control(''),
      numeroEmpInicial: this.fb.control({value: '', disabled: true}, Validators.pattern(this.pedEmpLiqPattern)),
      numeroEmpFinal: this.fb.control('', Validators.pattern(this.pedEmpLiqPattern)),
      escopoNumeroLiq: this.fb.control(''),
      numeroLiqInicial: this.fb.control({value: '', disabled: true}, Validators.pattern(this.pedEmpLiqPattern)),
      numeroLiqFinal: this.fb.control('', Validators.pattern(this.pedEmpLiqPattern)),
      numeroProcessoSei: this.fb.control('', Validators.pattern(this.processoSeiPattern)),
      tipoInformacaoCredor: this.fb.control(''),
      informacaoCredor: this.fb.control({value: '', disabled: true}),
      tipoInformacaoCredorConsignataria: this.fb.control(''),
      informacaoCredorConsignataria: this.fb.control({value: '', disabled: true}),
      historico: this.fb.control(''),
      escopoValorLiq: this.fb.control(''),
      valorLiqInicial: this.fb.control(''),
      valorLiqFinal: this.fb.control('')
    });
  }

  atualizarFormulario() {
    this.atualizarControle('dataInicial', this.filtro.dataInicial);
    this.atualizarControle('dataFinal', this.filtro.dataFinal);

    this.atualizarControle('escopoNumeroPed', this.setValorEscopo(this.filtro.escopoNumeroPed));
    this.atualizarControle('numeroPedInicial', this.filtro.numeroPedInicial);
    this.atualizarControle('numeroPedFinal', this.filtro.numeroPedFinal);

    this.atualizarControle('escopoNumeroEmp', this.setValorEscopo(this.filtro.escopoNumeroEmp));
    this.atualizarControle('numeroEmpInicial', this.filtro.numeroEmpInicial);
    this.atualizarControle('numeroEmpFinal', this.filtro.numeroEmpFinal);

    this.atualizarControle('escopoNumeroLiq', this.setValorEscopo(this.filtro.escopoNumeroLiq));
    this.atualizarControle('numeroLiqInicial', this.filtro.numeroLiqInicial);
    this.atualizarControle('numeroLiqFinal', this.filtro.numeroLiqFinal);

    this.atualizarControle('numeroProcessoSei', this.filtro.numeroProcessoSei);
    this.atualizarControle('historico', this.filtro.historico);

    this.atualizarControle('tipoInformacaoCredor', this.setValorEscopo(this.filtro.tipoInformacaoCredor));
    this.atualizarControle('informacaoCredor', this.filtro.informacaoCredor);

    this.atualizarControle('tipoInformacaoCredorConsignataria', this.setValorEscopo(this.filtro.tipoInformacaoCredorConsignataria));
    this.atualizarControle('informacaoCredorConsignataria', this.filtro.informacaoCredorConsignataria);

    this.atualizarControle('escopoValorLiq', this.setValorEscopo(this.filtro.escopoValorLiq));
    this.atualizarControle('valorLiqInicial', this.filtro.valorLiqInicial);
    this.atualizarControle('valorLiqFinal', this.filtro.valorLiqFinal);

    this.gerenciarControlesEscopoPed(this.formFiltro.get('escopoNumeroPed').value, false);
    this.gerenciarControlesEscopoEmp(this.formFiltro.get('escopoNumeroEmp').value, false);
    this.gerenciarControlesEscopoLiq(this.formFiltro.get('escopoNumeroLiq').value, false);
    this.gerenciarControlesEscopoValor(this.formFiltro.get('escopoValorLiq').value, false);

    this.gerenciarControleCredor(this.formFiltro.get('tipoInformacaoCredor').value, 'informacaoCredor', false, false);
    this.gerenciarControleCredor(this.formFiltro.get('tipoInformacaoCredorConsignataria').value, 'informacaoCredorConsignataria', true, false);
  }

  limparFormulario() {
    this.atualizarControle('dataInicial', '');
    this.atualizarValidadores('dataInicial', [Validators.required]);
    this.atualizarControle('dataFinal', '');
    this.atualizarValidadores('dataFinal', [Validators.required]);

    this.atualizarControle('escopoNumeroPed', '');
    this.gerenciarControlesEscopoPed('', true);

    this.atualizarControle('escopoNumeroEmp', '');
    this.gerenciarControlesEscopoEmp('', true);

    this.atualizarControle('escopoNumeroLiq', '');
    this.gerenciarControlesEscopoLiq('', true);

    this.atualizarControle('numeroProcessoSei', '');
    this.atualizarControle('historico', '');

    this.atualizarControle('tipoInformacaoCredor', '');
    this.gerenciarControleCredor('', 'informacaoCredor', false, true);

    this.atualizarControle('tipoInformacaoCredorConsignataria', '');
    this.gerenciarControleCredor('', 'informacaoCredorConsignataria', true, true);

    this.atualizarControle('escopoValorLiq', '');
    this.gerenciarControlesEscopoValor('', true);

  }

  salvarOnClick() {
    Object.keys(this.formFiltro.controls).forEach(key => {
      this.formFiltro.controls[key].markAsDirty();
    });

    if (this.formFiltro.invalid) {
      return;
    }

    // Atualizar o objeto do filtro.
    this.filtro.dataInicial = this.formFiltro.get('dataInicial').value;
    this.filtro.dataFinal = this.formFiltro.get('dataFinal').value;

    this.filtro.escopoNumeroPed =  this.getValorEscopo(this.formFiltro.get('escopoNumeroPed').value);
    this.filtro.numeroPedInicial = this.formFiltro.get('numeroPedInicial').value;
    this.filtro.numeroPedFinal = this.formFiltro.get('numeroPedFinal').value;

    this.filtro.escopoNumeroEmp = this.getValorEscopo(this.formFiltro.get('escopoNumeroEmp').value);
    this.filtro.numeroEmpInicial = this.formFiltro.get('numeroEmpInicial').value;
    this.filtro.numeroEmpFinal = this.formFiltro.get('numeroEmpFinal').value;

    this.filtro.escopoNumeroLiq = this.getValorEscopo(this.formFiltro.get('escopoNumeroLiq').value);
    this.filtro.numeroLiqInicial = this.formFiltro.get('numeroLiqInicial').value;
    this.filtro.numeroLiqFinal = this.formFiltro.get('numeroLiqFinal').value;

    this.filtro.numeroProcessoSei = this.formFiltro.get('numeroProcessoSei').value;
    this.filtro.historico = this.formFiltro.get('historico').value;

    this.filtro.tipoInformacaoCredor = this.getValorEscopo(this.formFiltro.get('tipoInformacaoCredor').value);
    this.filtro.informacaoCredor = this.formFiltro.get('informacaoCredor').value;

    this.filtro.tipoInformacaoCredorConsignataria = this.getValorEscopo(this.formFiltro.get('tipoInformacaoCredorConsignataria').value);
    this.filtro.informacaoCredorConsignataria = this.formFiltro.get('informacaoCredorConsignataria').value;

    this.filtro.escopoValorLiq = this.getValorEscopo(this.formFiltro.get('escopoValorLiq').value);
    this.filtro.valorLiqInicial = !this.isEmpty(this.formFiltro.get('valorLiqInicial').value) ? Number(this.formFiltro.get('valorLiqInicial').value) : null;
    this.filtro.valorLiqFinal = !this.isEmpty(this.formFiltro.get('valorLiqFinal').value) ? Number(this.formFiltro.get('valorLiqFinal').value) : null;

    RelLiquidacaoComponent.updateList.next(CloseModal.Confirma);
  }

  cancelarOnClick() {
    RelLiquidacaoComponent.updateList.next(CloseModal.Cancela);
  }

  limparOnClick() {
    this.limparFormulario();
  }

  /*
   * Evento OnChange de data.
   */
  dataOnChange(controlePrincipal: string, controleSecundario:string) {
    this.gerenciarControleData(controlePrincipal, controleSecundario);
  }

  gerenciarControleData(controlePrincipal: string, controleSecundario:string) {
    const inicial = this.formFiltro.get('dataInicial').value;
    const final = this.formFiltro.get('dataFinal').value;

    let validadores: ValidatorFn[];

    if (controlePrincipal === 'dataInicial') {
      // texto principal da mensagem de erro do limite superior.
      const msgMaxDataInicial = 'A data deve ser anterior ou igual à data ';

      // Define a data que será o limite superior. Se a data final tiver um valor será ela, caso contrário a data corrente.
      const maxDataInicial = this.isEmpty(final) ? this.hoje : final;

      // Complementa o texto da mensagem de erro do limite superior.
      this.msgErroMaxDataInicial = msgMaxDataInicial.concat(this.isEmpty(final) ? 'atual.' : 'final.');

      // Define os validadores de data inicial.
      validadores = [Validators.required, validateMaxDate(maxDataInicial)];
    }
    else if (controlePrincipal === 'dataFinal') {
      // Define os validadores de data final.
      validadores = [Validators.required, validateMinDate(inicial), validateMaxDate(this.hoje)]
    }

    this.atualizarValidadores(controlePrincipal, validadores);
    this.atualizarValidadores(controleSecundario, [Validators.required]);
  }

  escopoPedOnChange(valor: string) {
    this.gerenciarControlesEscopoPed(valor, true);
  }

  gerenciarControlesEscopoPed(valor: string, limparControles: boolean) {
    this.labelNumPedInicial = this.getLabelControleInicial(valor);
    this.exibirNumPedFinal = this.exibirControleFinal(valor);

    this.gerenciarControlesEscopo(valor, 'numeroPedInicial', 'numeroPedFinal', limparControles);
    this.atualizarValidadoresPedEmpLiq(valor, 'numeroPedInicial');
  }

  escopoEmpOnChange(valor: string) {
    this.gerenciarControlesEscopoEmp(valor, true);
  }

  gerenciarControlesEscopoEmp(valor: string, limparControles: boolean) {
    this.labelNumEmpInicial = this.getLabelControleInicial(valor);
    this.exibirNumEmpFinal = this.exibirControleFinal(valor);

    this.gerenciarControlesEscopo(valor, 'numeroEmpInicial', 'numeroEmpFinal', limparControles);
    this.atualizarValidadoresPedEmpLiq(valor, 'numeroEmpInicial');
  }

  escopoLiqOnChange(valor: string) {
     this.gerenciarControlesEscopoLiq(valor, true);
  }

  gerenciarControlesEscopoLiq(valor: string, limparControles: boolean) {
    this.labelNumLiqInicial = this.getLabelControleInicial(valor);
    this.exibirNumLiqFinal = this.exibirControleFinal(valor);

    this.gerenciarControlesEscopo(valor, 'numeroLiqInicial', 'numeroLiqFinal', limparControles);
    this.atualizarValidadoresPedEmpLiq(valor, 'numeroLiqInicial');
  }

  exibirControleFinal(valor: string): boolean {
    return valor === "2";
  }

  getLabelControleInicial(valor: string): string {
    return valor === '2' ? 'Inicial' : 'Valor';
  }

  atualizarValidadoresPedEmpLiq(valor: string, controleInicial: string) {
    this.atualizarValidadores(controleInicial, this.isEmpty(valor) ? null :
      valor === "1" ? [Validators.required, Validators.pattern(this.pedEmpLiqPattern)]
      : [Validators.pattern(this.pedEmpLiqPattern)]);
  }

  /*
  * Evento OnChange de Operador Lógico.
  */
  escopoValorOnChange(valor: string) {
    this.gerenciarControlesEscopoValor(valor, true);
  }

  gerenciarControlesEscopoValor(valor: string, limparControles: boolean) {
    this.labelValorLiqInicial = this.getLabelControleInicial(valor);
    this.exibirValorLiqFinal = this.exibirControleFinal(valor);

    this.gerenciarControlesEscopo(valor, 'valorLiqInicial', 'valorLiqFinal', limparControles);
    this.atualizarValidadores('valorLiqInicial', valor === "1" ? [Validators.required] : null);
  }

  /*
   * Gerencia o estado e o conteúdo do controle de valor especificado no parâmetro
   * e limpa o conteúdo do componente  inicial e final.
   */
  gerenciarControlesEscopo(valor: string, controleInicial: string, controleFinal: string, limparControles: boolean) {
    if (limparControles) {
      this.atualizarControle(controleInicial, '');
      this.atualizarControle(controleFinal, '');
    }

    this.habilitarControle(controleInicial, !this.isEmpty(valor));
  }

  /*
   * Evento OnChange de Tipo de iIformação de Credor.
   */
  tipoInfoOnChange(valor: string, controle: string, isConsignataria: boolean) {
    this.gerenciarControleCredor(valor, controle, isConsignataria, true);
  }

  /*
   * Gerencia o estado e o conteúdo do controle de valor especificado no parâmetro.
   */
  gerenciarControleCredor(valor: string, controle: string, isConsignataria: boolean, limparControle: boolean) {
    if (limparControle) {
      this.atualizarControle(controle, '');
    }

    this.habilitarControle(controle, !this.isEmpty(valor));

    this.atualizarValidadores(controle,  this.isEmpty(valor) ? null
      : [Validators.required, Validators.pattern(this.tiposInfoCredor[Number(valor)-1].pattern)]);

      // atualiza a máscara do input de acordo com a seleção do tipo de informação.
    const mascara = this.isEmpty(valor) ? '' : this.tiposInfoCredor[Number(valor)-1].mask;

    // atualiza a mensagem de erro de campo obrigatório de acordo com a seleção do tipo de informação.
    const msgErroCampoObrigatorio = this.isEmpty(valor) ? '' : this.tiposInfoCredor[Number(valor)-1].msgRequerido;

    if (isConsignataria) {
      this.credorMaskConsignataria = mascara;
      this.msgErroCredorConsignatariaRequerido = msgErroCampoObrigatorio;
    }
    else {
      this.credorMask =  mascara;
      this.msgErroCredorRequerido = msgErroCampoObrigatorio;
    }
  }

  /*
  * Atualiza o conteúdo do controle verificando a nulidade do futuro conteúdo.
  */
  atualizarControle(controle: string, value: any) {
    this.formFiltro.get(controle).setValue(value === null || value === undefined ? '' : value.toString());
  }

  habilitarControle(controle: string, habilitar: boolean) {
    if (habilitar) {
      this.formFiltro.get(controle).enable();
    }
    else {
      this.formFiltro.get(controle).disable();
    }
  }

  getValorEscopo(value: string): number {
    return !this.isEmpty(value) ? Number(value) : 0;
  }

  setValorEscopo(value: number): string {
    return value === null || value === undefined || value === 0 ? '' : value.toString();
  }

  /*
   * Exclui e recria os validadores do componente.
   */
  atualizarValidadores(controle: string, validadores: ValidatorFn[]) {

    if (validadores === null) {
      this.formFiltro.get(controle).clearValidators();
    }
    else {
      this.formFiltro.get(controle).setValidators(validadores);
    }

    this.formFiltro.get(controle).updateValueAndValidity();
  }
}

export function validateMaxDate(maxDate: any) {
	return (control: AbstractControl): { [key: string]: any } | null => {

    if (control.value !== undefined && control.value !== '') {

      const date = new Date(control.value).getTime();
      const max = new Date(maxDate).getTime();

		  return date <= max ? null : { 'validateMaxDate': true };
    }

    return null;
  }
}

export function validateMinDate(minDate: any) {
	return (control: AbstractControl): { [key: string]: any } | null => {

    if (control.value !== undefined && control.value !== '') {

      const date = new Date(control.value).getTime();
      const min = new Date(minDate).getTime();

		  return date >= min ? null : { 'validateMinDate': true };
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/relatorios/filtro-rel-liquidacao/filtro-rel-liquidacao.component.ts